import { App } from './app.js'
import './chrome.css'
import './grid.css'
import { registerSW } from 'virtual:pwa-register'
import { settleStartupAuthCodeSession } from './auth.js'
import { startLocalFirstBoot } from './boot.js'
import { applyStoredThemeMode } from './lib/themePreference.js'

console.debug('[lilo] local update probe 2026-02-06-4')

applyStoredThemeMode()

const app = new App()
void startLocalFirstBoot(app, {
  settleStartupAuthCodeSession,
  afterLocalBoot() {
    const updateSW = registerSW({
      immediate: true,
      onNeedRefresh() {
        app.notifyAppUpdateReady(async () => {
          await updateSW(true)
        })
      }
    })
  }
}).catch(() => {
  // App.start owns the one local-boot diagnostic. Rejection only prevents the
  // remote rail and service-worker handoff from treating that stop as success.
})
